// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "vendor." + chunkId + "." + {"3455":"d39ceb35dd773dc6","5848":"ba0ea27d785e732a"}[chunkId] + ".chunk.css";
};